import React from 'react';
import {SectionNotification} from '@wix/wix-ui-tpa';
import {useTranslation} from '@wix/yoshi-flow-editor';

export enum DeliveryNotificationDataHook {
  Root = 'DeliveryNotification.Root',
  Message = 'DeliveryNotification.Message',
}

export const DeliveryNotification = () => {
  const {t} = useTranslation();

  return (
    <div data-hook={DeliveryNotificationDataHook.Root}>
      <dl>
        <dt>
          <SectionNotification data-hook={DeliveryNotificationDataHook.Message}>
            <SectionNotification.Text>{t('cart.note.shipping.atCheckout')}</SectionNotification.Text>
          </SectionNotification>
        </dt>
      </dl>
    </div>
  );
};
